var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-inline-block"},[_c('fa-icon',{attrs:{"icon":"calendar-alt"}}),_vm._v(" "+_vm._s(_vm.date)+" "),_c('fa-icon',{attrs:{"icon":"clock"}}),_vm._v(" "+_vm._s(_vm.time)+"\n")],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3bf0cee9","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/general/DateDisplay.vue
// module id = 295
// module chunks = 1